import React from 'react';
import Link from 'next/link';

import { cn } from '~/lib/utils';
import clsx from 'clsx';
import {
  ExternalLink,
  FileDown,
  Link as LinkIcon,
  Map,
  SignpostBig,
  SquarePlay,
} from 'lucide-react';

enum LinkType {
  NORMAL,
  MAP,
  DOWNLOAD,
  BLOG,
  YOUTUBE,
}

const IconLink = ({
  href,
  button = false,
  block = false,
  className,
  children,
  id,
  overrideNewTab = false,
}: {
  id?: string;
  href: string;
  button?: boolean;
  block?: boolean;
  className?: string;
  children: React.ReactNode;
  overrideNewTab?: boolean;
}) => {
  let linkType = LinkType.NORMAL;
  if (href.startsWith('#')) {
    return (
      <a href={href} id={id}>
        {children}
      </a>
    );
  }

  if (
    href.startsWith('https://maps.app.goo.gl/') ||
    href.startsWith('https://www.google.com/maps/')
  ) {
    linkType = LinkType.MAP;
  }

  if (href.startsWith('https://www.youtube.com')) {
    linkType = LinkType.YOUTUBE;
  }

  let internal = false;

  if (href.startsWith('/')) {
    internal = true;
    if (href.startsWith('/blog')) {
      linkType = LinkType.BLOG;
    }
    if (href.indexOf('.') > 0) {
      linkType = LinkType.DOWNLOAD;
    }
  }

  if (href.includes('api/media/file/')) {
    linkType = LinkType.DOWNLOAD;
  }

  const target =
    overrideNewTab === undefined
      ? linkType == LinkType.BLOG
        ? '_self'
        : '_blank'
      : overrideNewTab || !href.startsWith('/')
        ? '_blank'
        : '_self';
  return (
    <Link
      href={href}
      target={target}
      rel={internal ? '' : 'noreferrer'}
      className={cn(
        clsx(
          button
            ? 'bg-primary text-primary-foreground hover:bg-primary/90 rounded px-4 py-2'
            : 'hover:border-black',
          'border-b no-underline transition duration-100',
          'border-transparent',
        ),
        className,
      )}
    >
      <span
        className={clsx(
          block ? 'flex' : 'inline-flex',
          'items-center gap-1 pb-1 align-middle',
        )}
      >
        {children}
        {(() => {
          if (target === '_blank') {
            return <ExternalLink size={15} className="inline" />;
          } else if (linkType === LinkType.MAP) {
            return <Map size={15} className="inline" />;
          } else if (linkType === LinkType.YOUTUBE) {
            return <SquarePlay size={15} className="inline" />;
          } else if (linkType === LinkType.DOWNLOAD) {
            return <FileDown size={15} className="inline" />;
          } else if (linkType === LinkType.BLOG) {
            return <SignpostBig size={15} className="inline" />;
          } else {
            return <LinkIcon size={15} className="inline" />;
          }
        })()}
      </span>
    </Link>
  );
};

export default IconLink;
